// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"336":"75a67fea","424":"0386661a","549":"0386661a"}[chunkId] + ".chunk.css";
};